<template>
  <div class="landing-container">
    <!-- Hero Section Moderno -->
    <main class="main-section">
      <div class="hero-content">
        <img
          class="logo-main"
          src="img/eleva/eleva.png"              
          alt="Logo eleva"
        />
        <h1 class="hero-title">eleva tu aprendizaje de manera activa</h1>
        <button class="btn-login" @click="redirectToLogin">
          <span>Iniciar sesión</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
      
      <!-- Olas SVG -->
      <svg class="waves" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
        <path fill="#fff" fill-opacity="1" d="M0,224L60,197.3C120,171,240,117,360,133.3C480,149,600,235,720,266.7C840,299,960,277,1080,229.3C1200,181,1320,107,1380,69.3L1440,32L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
      </svg>
    </main>

    <!-- Sección "¿Qué es eleva?" -->
    <section id="about-section" class="about-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8 text-center">
            <h2 class="about-title">¿Qué es <span class="text-eleva">eleva</span>?</h2>
            <p class="about-description">
              Una dinámica plataforma de formación docente enfocada en el desarrollo de 
              competencias tecnológicas, educativas y didácticas, proporcionando a los educadores los 
              conocimientos, herramientas y recursos necesarios para mejorar sus prácticas de 
              enseñanza para mantenerse al día con el cambiante panorama de la educación mediada 
              por la tecnología.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Sección de características/beneficios -->
    <section class="features-section">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-12 col-md-10 text-center">
            <h2 class="features-title">La plataforma ofrece los siguientes beneficios:</h2>
          </div>
        </div>

        <div class="row g-4">
          <!-- Card 1: Selección integral de cursos -->
          <div class="col-12 col-md-6">
            <div class="benefit-card">
              <div class="icon-circle purple-icon">
                📚
              </div>
              <h3 class="benefit-title">Selección integral de cursos</h3>
              <p class="benefit-description">
                eleva ofrece una amplia variedad de cursos que atienden a las diversas necesidades e intereses de los educadores, asegurando que puedan encontrar contenido relevante y atractivo. El programa hace parte de estos cursos de formación.
              </p>
            </div>
          </div>

          <!-- Card 2: Eleva tu metodología -->
          <div class="col-12 col-md-6">
            <div class="benefit-card">
              <div class="icon-circle orange-icon">
                🚀
              </div>
              <h3 class="benefit-title">Eleva tu metodología</h3>
              <p class="benefit-description">
                Serie de pláticas y webinars educativos que te ayudarán a potenciar la educación de la mano de nuestro equipo, conociendo: metodologías activas, charlas de tecnología educativa y las más recientes innovaciones tecno pedagógicas.
              </p>
            </div>
          </div>

          <!-- Card 3: Cursos sobre herramientas de Google -->
          <div class="col-12 col-md-6">
            <div class="benefit-card">
              <div class="icon-circle google-icon">
                <img
                  class="img-fluid d-block"
                  src="img/google-logo.png"              
                  alt="google-logo"
                />
              </div>
              <h3 class="benefit-title">Cursos sobre herramientas de Google</h3>
              <p class="benefit-description">
                La plataforma cuenta con cursos autogestivos que exploran las diversas herramientas que ofrece Google for Education. El contenido de los cursos pueden preparar a los usuarios en su camino para las certificaciones de Google for Education Nivel 1 y Nivel 2.
              </p>
            </div>
          </div>

          <!-- Card 4: Video tutoriales sobre aplicaciones aliadas -->
          <div class="col-12 col-md-6">
            <div class="benefit-card">
              <div class="icon-circle purple-light-icon">
                🎥
              </div>
              <h3 class="benefit-title">Vídeo tutoriales sobre aplicaciones aliadas</h3>
              <p class="benefit-description">
                Como parte de los programas upgrade que ofrece activa, contamos con alianzas con diversas aplicaciones educativas que elevarán tu práctica educativa. En esta sección encontrarás videos que te enseñarán a utilizar dichas aplicaciones y aplicarlas en tu práctica educativa cotidiana.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer modificado -->
    <footer class="footer-landing text-white py-3 py-md-4 mt-5">
      <div class="container">
        <div class="row">
          <!-- Columna 1 -->
          <div class="col-12 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <div class="d-flex align-items-center mb-1 mb-md-2">
              <img
                class="img-fluid d-block logo-footer"
                src="img/eleva/eleva_blanco_full.png"              
                alt="Logo eleva"
              />
            </div>
            <p class="small mb-0">Preparación profesional.</p>
          </div>

          <!-- Columna 2 -->
          <div class="col-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <h5 class="fw-semibold mb-1 mb-md-2 footer-title">Producto</h5>
            <ul class="list-unstyled small mb-0">
              <li class="mb-1"><a href="#about-section" @click="scrollToSection" class="text-decoration-none link-footer">Características</a></li>              
            </ul>
          </div>

          <!-- Columna 3 -->
          <div class="col-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
            <h5 class="fw-semibold mb-1 mb-md-2 footer-title">Soporte</h5>
            <ul class="list-unstyled small mb-2">
              <li class="mb-1"><a href="https://activa.la/soporte/" target="_blank" class="text-decoration-none link-footer">Centro de Ayuda</a></li>              
            </ul>
            <h5 class="fw-semibold mb-1 mb-md-2 footer-title">Redes Sociales</h5>
            <div class="d-flex gap-2 social-icons">              
              <a href="https://www.facebook.com/share/1CRCXeQHGE/" target="_blank" class="btn-social">
                <img
                  class="img-fluid d-block"
                  src="img/sociales/facebook-logo.png"              
                  alt="facebook-logo"
                />
              </a>
              <a href="https://www.instagram.com/activa_edu?igsh=MW5sbm51dXJrdHdsbg==" target="_blank" class="btn-social">
                <img
                  class="img-fluid d-block"
                  src="img/sociales/instagram-logo.png"
                  alt="instagram-logo"
                />
              </a>              
              <a href="https://x.com/activa_edu" target="_blank" class="btn-social">
                <img
                  class="img-fluid d-block"
                  src="img/sociales/x-logo.png"              
                  alt="x-logo"
                />
              </a>
              <a href="https://www.linkedin.com/company/activa-la/" target="_blank" class="btn-social">
                <img
                  class="img-fluid d-block"
                  src="img/sociales/linkedin-logo.png"              
                  alt="linkedin-logo"
                />
              </a>
              <a href="http://www.youtube.com/@activa_edu" target="_blank" class="btn-social">
                <img
                  class="img-fluid d-block"
                  src="img/sociales/youtube-logo.png"              
                  alt="youtube-logo"
                />
              </a>
            </div>
          </div>

          <!-- Columna 4 -->
          <div class="col-12 col-md-6 col-lg-3">
            <h5 class="fw-semibold mb-1 mb-md-2 footer-title">Dirección</h5>
            <p class="small opacity-75 mb-0 address-text">
              Bosque de Radiatas 54 Int 201,<br>
              Bosques de las Lomas, Cuajimalpa de Morelos,<br>
              05120 Ciudad de México, CDMX
            </p>
          </div>
        </div>

        <hr class="border-light opacity-50 my-3">

        <div class="text-center">
          <p class="small opacity-75 mb-0 copyright-text">
            © {{ new Date().getFullYear() }} activa | {{ appName }}. Todos los derechos reservados. |
            <a href="#" class="link-footer">Política de Privacidad</a> |
            <a href="#" class="link-footer">Términos de Servicio</a>
          </p>
        </div>
      </div>
    </footer>

    <!-- Botón flotante para volver arriba -->
    <button v-show="showScrollTop" class="scroll-to-top" @click="scrollToTop" aria-label="Volver arriba">
      ↑
    </button>
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  data() {
    return {
      vurl: process.env.VUE_APP_URL + "/login",
      appName: "eleva",
      showScrollTop: false
    }
  },
  methods: {
    redirectToLogin() {
      window.location.href = this.vurl;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollToSection(event) {
      event.preventDefault();
      const targetId = event.target.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const offsetTop = targetElement.offsetTop - 100; // Offset para header si existe
        window.scrollTo({ 
          top: offsetTop, 
          behavior: 'smooth' 
        });
      }
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 300;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Encode+Sans:wght@400;500&display=swap');

/* Scroll suave para toda la página */
html {
  scroll-behavior: smooth;
}

.landing-container {
  font-family: 'Poppins', sans-serif;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Hero Section Moderno */
.main-section {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(114deg, #fff4f3 0%, #eadfff 100%);
  overflow: hidden;
}

.hero-content {
    position: relative;
    z-index: 2;
    text-align: center;
    max-width: 900px;
    margin: 0 auto;
    padding: 2rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    min-height: 100vh;
}

.logo-main {
  width: 100%;  
  height: auto;
  margin: 0 auto 2rem;
  display: block;
  animation: fadeInDown 0.8s ease-out;
}

.hero-title {
  font-family: 'Encode Sans', sans-serif;
  font-weight: 500;
  font-size: clamp(1.5rem, 4vw, 2.5rem);
  color: #4a5568;
  margin: 0 0 2.5rem;
  line-height: 1.4;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.btn-login {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: linear-gradient(135deg, #FF5722 0%, #FF00A8 50%, #8A2BE2 100%);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 25px rgba(255, 0, 168, 0.3);
  animation: fadeInUp 0.8s ease-out 0.4s both;
  position: relative;
  overflow: hidden;
}

.btn-login::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.btn-login:hover::before {
  left: 100%;
}

.btn-login:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 35px rgba(255, 0, 168, 0.4);
}

.btn-login:active {
  transform: translateY(-1px);
}

.btn-login svg {
  transition: transform 0.3s ease;
}

.btn-login:hover svg {
  transform: translateX(5px);
}

/* Olas */
.waves {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 200px;
  z-index: 1;
}

/* Animaciones */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .logo-main {    
    margin-bottom: 1.5rem;
  }
  
  .hero-title {
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }
  
  .btn-login {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }
  
  .waves {
    min-height: 100px;
  }
}

@media (max-width: 480px) {  
  .hero-title {
    font-size: 1.25rem;
  }
  
  .btn-login {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
  }
}

/* Sección "¿Qué es eleva?" */
.about-section {
  padding: 4rem 1rem;  
}

.about-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 2rem;
}

.text-eleva {
  color: #9E61FF;
}

.about-description {
  font-family: 'Encode Sans', sans-serif;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 1.7;
  color: #666;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

/* Sección de características */
.features-section {
  padding: 4rem 1rem;
  background: #fff;
}

/* Espaciado entre rows de cards de beneficios */
.features-section .row.g-4 > .col-12 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.features-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 3rem;
  text-align: center;
}

.benefit-card {
  background: #fff;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #f1f1f1;
  height: 100%;
  transition: all 0.3s ease;
}

.benefit-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  margin-bottom: 20px;
}

.purple-icon { 
  background-color: #9E61FF; 
}

.orange-icon { 
  background-color: #FF5E20; 
}

.google-icon { 
  background-color: #fff; 
  border: 1px solid #dadada;  
}

.purple-light-icon { 
  background-color: #B794F6; 
}

.benefit-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 1.5rem;
  color: #1a1a1a;
  margin-bottom: 1rem;
  line-height: 1.3;
}

.benefit-description {
  font-family: 'Encode Sans', sans-serif;
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #4a5568;
  text-align: left;
}

/* Footer modificado */
.footer-landing {
  background: linear-gradient(90deg, #FF5722, #FF00A8, #8A2BE2);
  max-height: 250px; /* Límite máximo de altura */
  overflow: hidden; /* Evita que el contenido se desborde */
}

.logo-footer {
  max-width: 100px; /* Reducido de 120px */
}

.footer-title {
  font-size: 1rem; /* Reducido de 1.1rem */
  color: #fff;
}

.link-footer {
  color: rgba(255,255,255,0.85);
  transition: color 0.2s ease-in-out;
  font-size: 0.85rem; /* Reducido de 0.9rem */
}

.link-footer:hover {
  color: #fff;
}

.btn-social {
  width: 32px; /* Reducido de 36px */
  height: 32px; /* Reducido de 36px */
  border: 1px solid rgba(255,255,255,0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  color: white;
}

.btn-social:hover {
  background: rgba(255,255,255,0.2);
  transform: scale(1.1);
}

.btn-social svg {
  width: 16px; /* Reducido de 18px */
  height: 16px; /* Reducido de 18px */
}

.address-text {
  line-height: 1.4; /* Reducido de 1.5 */
  font-size: 0.85rem; /* Añadido para reducir tamaño */
}

.copyright-text {
  font-size: 0.8rem; /* Reducido de 0.85rem */
  line-height: 1.4; /* Reducido de 1.6 */
}

/* Botón flotante para volver arriba */
.scroll-to-top {
  position: fixed;
  right: 32px;
  bottom: 32px;
  z-index: 1000;
  background: linear-gradient(90deg, #FF5722, #FF00A8, #8A2BE2);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.4s, transform 0.2s;
}

.scroll-to-top:hover {
  transform: scale(1.12) rotate(-10deg);
  box-shadow: 0 8px 24px rgba(0,0,0,0.22);
}

/* Media queries para responsividad */

/* Media queries para responsividad */
@media (max-width: 768px) {
  .main-section {
    padding: 1.5rem 1rem;
    max-height: 90vh !important;
    min-height: 70vh;
  }
  
  .subtitle {
    font-size: 0.9rem;
    margin: 0.8rem 0 1.5rem;
  }
  
  .btn-login {
    padding: 0.8rem 1.8rem;
    font-size: 0.9rem;
  }

  /* Secciones nuevas responsive */
  .about-section {
    padding: 3rem 1rem;
  }

  .about-title {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
  }

  .about-description {
    font-size: 1rem;
    line-height: 1.6;
    text-align: left;
  }

  .features-section {
    padding: 3rem 1rem;
  }

  .features-title {
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }

  .benefit-card {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .icon-circle {
    width: 50px;
    height: 50px;
    font-size: 20px;
    margin-bottom: 15px;
  }

  .benefit-title {
    font-size: 1.3rem;
    margin-bottom: 0.8rem;
  }

  .benefit-description {
    font-size: 1rem;
    line-height: 1.5;
  }
  
  .footer-landing {
    padding: 1rem 0 !important; /* Reducido de 1.5rem */
    max-height: none; /* Permitir que crezca en móviles */
  }
  
  .logo-footer {
    max-width: 80px; /* Reducido de 100px */
  }
  
  .footer-title {
    font-size: 0.9rem; /* Reducido de 1rem */
    margin-bottom: 0.5rem !important; /* Reducido de 0.8rem */
  }
  
  .link-footer {
    font-size: 0.8rem; /* Reducido de 0.85rem */
  }
  
  .btn-social {
    width: 28px; /* Reducido de 32px */
    height: 28px; /* Reducido de 32px */
  }
  
  .btn-social svg {
    width: 14px; /* Reducido de 16px */
    height: 14px; /* Reducido de 16px */
  }
  
  .address-text {
    font-size: 0.8rem !important; /* Reducido de 0.85rem */
  }
  
  .copyright-text {
    font-size: 0.75rem; /* Reducido de 0.8rem */
  }
}

@media (max-width: 576px) {
  .subtitle {
    font-size: 0.85rem;
  }
  
  .btn-login {
    padding: 0.7rem 1.5rem;
    font-size: 0.85rem;
  }

  /* Secciones nuevas para móviles pequeños */
  .about-section {
    padding: 2.5rem 1rem;
  }

  .about-title {
    font-size: 1.6rem;
    margin-bottom: 1.2rem;
  }

  .about-description {
    font-size: 0.95rem;
  }

  .features-section {
    padding: 2.5rem 1rem;
  }

  .features-title {
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }

  .benefit-card {
    padding: 1.2rem;
    border-radius: 15px;
  }

  .icon-circle {
    width: 45px;
    height: 45px;
    font-size: 18px;
    margin-bottom: 12px;
  }

  .benefit-title {
    font-size: 1.1rem;
  }

  .benefit-description {
    font-size: 0.9rem;
  }
  
  .footer-landing {
    text-align: center;
  }
  
  .social-icons {
    justify-content: center;
  }
  
  .copyright-text {
    font-size: 0.7rem; /* Reducido de 0.75rem */
  }
}
</style>